<template>
  <div v-if="invoice" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="invoice">
      <InvoiceForm :invoice="invoice" @update:invoice="invoiceLocalUpdate" @save="handleSave" />

      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :model="invoice"
            modelEditRoute="InvoiceEditPage"
            modelListRoute="InvoicesPage"
            modelRouteParamName="invoiceNumber"
            :updateCallback="updateInvoice"
            :createCallback="createInvoice"
            :deleteCallback="deleteInvoice"
            :fetchPaginatedCallback="fetchInvoicesPaginated"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';
import InvoiceForm from '@/components/Invoices/InvoiceForm.vue';

export default {
  name: 'InvoiceEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
    InvoiceForm,
  },
  props: {
    invoiceNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
    };
  },
  computed: {
    ...mapGetters(['getInvoiceByNumber']),
    buttons() {
      return {
        showDeleteButton: this.invoice && this.invoice.number !== '_new' ? true : false,
      };
    },
    invoice() {
      return this.getInvoiceByNumber(this.number);
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('invoices'), route: { name: 'InvoicesPage' } },
        { name: this.invoice.number !== '_new' ? this.$t('edit') : this.$t('new') },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchInvoicesPaginated',
      'fetchInvoiceByNumber',
      'updateInvoice',
      'createInvoice',
      'deleteInvoice',
      'initInvoice',
      'invoiceLocalUpdate',
    ]),

    async handleSave(invoice) {
      if (invoice.number === '_new') {
        await this.createInvoice(invoice);
      } else {
        await this.updateInvoice(invoice);
      }
    },
  },
  async mounted() {
    console.log('InvoiceEdit:mounted', this.invoiceNumber);
    if (!this.invoice && this.invoiceNumber) {
      this.number = this.invoiceNumber;
      await this.fetchInvoiceByNumber(this.number);
    } else {
      this.initInvoice();
      this.number = '_new';
    }
  },
  watch: {
    invoice(newValue, oldValue) {
      console.log('InvoiceEdit:invoice changed', newValue);
    },
  },
};
</script>

<style scoped lang="scss">
.p-calendar {
  width: 100%;
}
</style>
